export type ScrollAnchorType = {
  id: string
  ifNearTop?: boolean
}

export type ScrollType = false | 'top' | ScrollAnchorType

export const SCROLL_GALLERY: ScrollAnchorType = { id: 'gallery', ifNearTop: true }
export const SCROLL_NAVTABS: ScrollAnchorType = { id: 'nav-tabs', ifNearTop: true }
